import React, { useCallback, useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';

import { MaterialIcon } from '@pearsontechnology/aero-components';

import appConfig from 'appConfig';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';

import messages from '../messages';
import {
  Article,
  ContentHeader,
  ThumbnailGrid,
  Title,
  ViewMore,
  Wrapper,
} from './styles';
import ThumbnailCard from './ThumbnailCard';
import SearchContainer from './SearchContainer';
import ArticleView from './ArticleView';

function HelpView({ helpContext }) {
  const SEARCH_FILE = 'searchData.json';
  const [searchData, setSearchData] = useState({});
  const [filteredData, setFilteredData] = useState({});
  const [searchFilter, setSearchFilter] = useState('');
  const [articleView, showArticleView] = useState(false);
  const [articleUrl, setArticleUrl] = useState('');
  const helpCentreUrl = appConfig.getHelpCentreURL();

  useEffect(() => {
    async function getSearchData() {
      const data = await fetch(`${helpCentreUrl}/${SEARCH_FILE}`)
        .then((response) => response.json());

      setSearchData(data);
      setFilteredData(helpContext ? filterSearchData(data) : data);
    }

    getSearchData();
  }, [filterSearchData, helpCentreUrl, helpContext]);

  const filterSearchData = useCallback((searchItems) => {
    const filteredSearchData = Object.entries(searchItems)
      // eslint-disable-next-line no-unused-vars
      .filter(([key, searchItemAttributes]) => searchItemAttributes.tags.includes(helpContext))
      .reduce((acc, searchItem) => ({
        ...acc,
        [searchItem[0]]: searchItem[1],
      }), {});
    return filteredSearchData;
  }, [helpContext]);

  function showArticle(url) {
    setArticleUrl(url);
    showArticleView(true);
  }

  function updateSearch(filter, searchResults) {
    setSearchFilter(filter);
    setFilteredData(searchResults);
  }

  function resetSearch() {
    setSearchFilter('');
    setFilteredData(helpContext ? filterSearchData(searchData) : searchData);
  }

  return (
    <Fragment>
      {articleView && (
        <ArticleView
          helpCentreUrl={helpCentreUrl}
          articleUrl={articleUrl}
          showArticleView={showArticleView}
        />
      )}
      {!articleView && (
        <Wrapper>
          <Title>{intl.formatMessage(messages.helpTitle)}</Title>
          <SearchContainer
            searchData={searchData}
            searchFilter={searchFilter}
            updateSearch={updateSearch}
            resetSearch={resetSearch}
          />
          <ContentHeader>
            <Article>
              {searchFilter && intl.formatMessage(messages.similar)}
              {helpContext && !searchFilter && intl.formatMessage(messages[helpContext])}
              {` ${intl.formatMessage(messages.articles)}`}
            </Article>
            <ViewMore href={helpCentreUrl} target="_blank">
              {intl.formatMessage(messages.viewMore)}
              <MaterialIcon id="open_in_new"></MaterialIcon>
            </ViewMore>
          </ContentHeader>
          <ThumbnailGrid>
            {Object.entries(filteredData).map(
              ([key, data]) => (
                <ThumbnailCard
                  key={key}
                  handleOnClick={() => showArticle(data.url)}
                  title={data.title}
                  thumbnailUrl={data.thumbnail && `${helpCentreUrl}${data.thumbnail}`}
                />
              ))
            }
          </ThumbnailGrid>
        </Wrapper>
      )}
    </Fragment>
  );
}

HelpView.propTypes = {
  helpContext: PropTypes.string,
};

export default HelpView;
